import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const CloudboxIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M14.94,11.46l-4.76-1.9c-.11-.05-.24-.05-.35,0l-4.76,1.9c-.18.07-.3.25-.3.44v5.71c0,.19.12.37.3.44l4.75,1.9h0s0,0,0,0c.06.02.12.03.18.03s.12-.01.18-.03h0s0,0,0,0l4.75-1.9c.18-.07.3-.25.3-.44v-5.71c0-.19-.12-.37-.3-.44h0ZM9.52,18.82l-3.81-1.52v-4.69l3.81,1.52v4.69h0ZM10,13.3l-3.48-1.39,3.48-1.39,3.48,1.39-3.48,1.39ZM14.29,17.3l-3.81,1.52v-4.69l3.81-1.52v4.69ZM20,9.05c0,2.03-1.43,3.74-3.33,4.17v-.99c1.37-.41,2.38-1.67,2.38-3.18,0-1.84-1.5-3.33-3.33-3.33h-.95c-.26,0-.48-.21-.48-.48,0-2.36-1.92-4.29-4.29-4.29s-4.29,1.92-4.29,4.29c0,.26-.21.48-.48.48h-.95c-1.84,0-3.33,1.5-3.33,3.33,0,1.5,1.01,2.77,2.38,3.18v.99c-1.9-.44-3.33-2.14-3.33-4.17,0-2.36,1.92-4.29,4.29-4.29h.5c.24-2.67,2.49-4.76,5.22-4.76s4.98,2.1,5.22,4.76h.5c2.36,0,4.29,1.92,4.29,4.29Z" />
 </svg>,
 "Cloudbox"
);
